export const INSTRUCTIONS_MAX = 16000;
